import type { OptionMapping } from "@gatsby-plugin-marketplace/fragments/optionMapping"
import type { SaleConfiguration } from "~/fragments/saleConfigurations"
import isEmpty from "~/lib/isEmpty"
import { useAppSelector } from "~/store/hooks"
import { getSaleConfiguration } from "~/store/marketplace/selectors"
import { getSelectedPlanSettings } from "~/utils"

export default function useCurrentPlanSettings(
  saleConfiguration?: SaleConfiguration
): OptionMapping | null {
  const uuid = saleConfiguration?.id

  const saleConfigurationState = useAppSelector((state) =>
    uuid ? getSaleConfiguration(state, uuid) : null
  )

  if (isEmpty(saleConfigurationState)) {
    return null
  }

  return getSelectedPlanSettings(
    saleConfiguration?.flatData.optionsMapping || [],
    saleConfigurationState.options
  )
}
